export const globalCss = {
  html: {
    colorScheme: 'light',
    _dark: { colorScheme: 'dark' },
  },
  body: {
    bg: 'bg.canvas',
    color: 'fg.default',
    fontFamily: 'body',
    fontSize: 'md',
    lineHeight: 'normal',
    WebkitFontSmoothing: 'antialiased',
    textRendering: 'optimizeLegibility',
    // Only the page surface cross-fades on a mode change, so the switch reads as
    // one movement rather than a cascade.
    transitionProperty: 'background-color, color',
    transitionDuration: 'normal',
    transitionTimingFunction: 'standard',
  },
  '*, *::before, *::after': {
    borderColor: 'border.default',
  },
  '*:focus-visible': {
    outline: '2px solid',
    outlineColor: 'focus.ring',
    outlineOffset: '2px',
    borderRadius: 'sm',
  },
  '*:focus:not(:focus-visible)': {
    outline: 'none',
  },
  '::selection': {
    bg: 'brand.muted',
    color: 'brand.fg',
  },
  '::-webkit-scrollbar': { width: '10px', height: '10px' },
  '::-webkit-scrollbar-thumb': {
    bg: 'border.strong',
    borderRadius: 'full',
    border: '3px solid transparent',
    backgroundClip: 'content-box',
  },
  '::-webkit-scrollbar-thumb:hover': { bg: 'fg.subtle' },
  '::-webkit-scrollbar-track': { bg: 'transparent' },

  '@media (prefers-reduced-motion: reduce)': {
    '*, *::before, *::after': {
      animationDuration: '0.01ms !important',
      animationIterationCount: '1 !important',
      transitionDuration: '0.01ms !important',
      scrollBehavior: 'auto !important',
    },
  },
}
